module.exports = __webpack_public_path__ + "static/media/Group 37399.9a0ee1b0.png";